<template>
  <div class="page" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} Purchase Order</h2>
      <button type="button" class="btn-outline btn-cetak" @click="cetak()">
        Cetak
      </button>

      <br />

      <div class="form-wrapper">
        <div class="form-top">
          <div>
            <div class="form-group">
              <label for="">No PO</label>
              <input type="text" v-model="po.no_po" style="padding: 10px" />
            </div>
            <div class="form-group">
              <label for="">Tgl Transaksi</label>
              <date-range-picker
                v-model="dateRange"
                single-date-picker="true"
                :auto-apply="true"
              >
                <template v-slot:input="picker">
                  {{ moment(picker.startDate).format("DD MMM YYYY") }}
                </template>
              </date-range-picker>
            </div>
          </div>
          <div>
            <div class="form-group">
              <label for="">Supplier</label>
              <select v-model="po.id_perusahaan">
                <option value="-1">
                  {{
                    loadingSupplier ? "Loading supplier..." : "Tanpa Supplier"
                  }}
                </option>
                <option
                  v-for="(item, index) in dataSupplier"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.nama }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="">Penerima</label>
              <select v-model="po.id_penerima">
                <option v-if="loadingPenerima" value="-1">
                  Loading outlet...
                </option>
                <option
                  v-for="(item, index) in dataOutlet"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.nama }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label>Catatan</label>
            <textarea rows="5" v-model="po.keterangan"></textarea>
          </div>
        </div>

        <p>Detail Item</p>

        <div class="table-wrappers">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20px">No</th>
                <th style="width: 35%">Nama Barang</th>
                <th style="width: 150px">Harga</th>
                <th style="width: 100px">Per</th>
                <th style="width: 100px">Satuan</th>
                <th style="width: 150px">Jumlah Dibeli</th>
                <th style="width: 150px">Total</th>
                <th style="width: 60px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in detail" :key="index">
                <td>{{ ++index }}</td>
                <td>
                  <span v-show="!row.show">{{ row.nama }}</span>

                  <Autocomplete
                    v-show="row.show"
                    v-model="row.nama"
                    :nama="row.nama"
                    :items="dataBahanBaku"
                    @selected="setRow($event, row)"
                  />
                </td>
                <td>
                  <input type="number" v-model="row.harga" :disabled="row.id_barang == -1"/>
                </td>
                <td>
                  <input type="text" v-model="row.per" :disabled="row.id_barang == -1"/>
                </td>
                <td>
                  <input type="text" v-model="row.satuan" :disabled="row.id_barang == -1"/>
                </td>
                <td>
                  <input
                    type="number"
                    v-model="row.jumlah"
                    style="text-align: center"
                    :disabled="row.id_barang == -1"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    :value="row.harga * row.jumlah"
                    readonly
                    style="text-align: right"
                    :disabled="row.id_barang == -1"
                  />
                </td>
                <td align="right">
                  <a
                    href="javascript:void(0)"
                    class="btn-hapus"
                    @click="remove(row, index)"
                    >Hapus</a
                  >
                </td>
              </tr>
              <tr @click="tambahBarang">
                <td></td>
                <td colspan="4">
                  <span class="btn-tambah-barang">Tambah Barang</span>
                </td>
                <td colspan="2">
                  <div style="display: flex; justify-content: space-between">
                    <b>Grand Total</b>
                    <b>Rp {{ grandTotal | number }}</b>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pembayaran">
          <div>
            <p style="margin: 0">Pembayaran</p>
            <ul>
              <li v-for="(item, index) in pembayaran" :key="index">
                <span>
                  {{ moment(item.created_at).format("DD/MM/YYYY HH:mm") }}
                </span>
                <span> Rp {{ item.jumlah_bayar | number }} </span>
              </li>
              <li>
                <input
                  type="tel"
                  v-model="po.jumlah_bayar"
                  placeholder="Input jumlah bayar"
                  @keyup.enter="save()"
                />
              </li>
              <li>
                <div>Sisa bayar</div>
                <div>
                  <b>Rp {{ (grandTotal - totalBayar) | number }}</b>
                </div>
              </li>
            </ul>

            <div class="btn-grid">
              <button
                type="button"
                class="btn btn-fill"
                @click="save"
                :disabled="loadingButton"
              >
                Simpan
              </button>
              <button
                type="button"
                class="btn-outline"
                @click="$router.go(-1)"
                :disabled="loadingButton"
              >
                Kembali
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="faktur-print">
      <h2>Purchase Order</h2>

      <table>
        <tr>
          <td>No PO</td>
          <td>:</td>
          <td>{{ po.no_po }}</td>

          <td colspan="2">
            <div style="width: 100px"></div>
          </td>

          <td>Supplier</td>
          <td>:</td>
          <td>{{ getSupplier(po.id_perusahaan) }}</td>
        </tr>
        <tr>
          <td>Tanggal</td>
          <td>:</td>
          <td>{{ moment(po.tanggal).format("DD/MM/YYYY") }}</td>

          <td colspan="2"></td>

          <td>Penerima</td>
          <td>:</td>
          <td>{{ getPenerima(po.id_penerima) }}</td>
        </tr>
      </table>

      <p>Detail Item</p>
      <table class="table-detail">
        <thead>
          <tr>
            <th>No</th>
            <th>Nama Barang</th>
            <th>Harga</th>
            <th style="text-align: right">Jumlah</th>
            <th style="text-align: right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in detail" :key="index">
            <td>{{ ++index }}</td>
            <td>
              {{ row.nama }}
            </td>
            <td>{{ row.harga | number }} / {{ row.per }} {{ row.satuan }}</td>
            <td style="text-align: right">
              {{ row.jumlah }}
            </td>
            <td style="text-align: right">
              {{ (row.harga * row.jumlah) | number }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4"><b>Total</b></td>
            <td align="right">
              <b>{{ grandTotal | number }}</b>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";


import moment from "moment";
import * as api from "../../api/Api";

import Autocomplete from "../../custom/Autocomplete.vue";

import Back from "../icons/Back.vue";
import Search from "../icons/Search.vue";
import Close from "../icons/Close.vue";

export default {
  name: "PurchaseOrderForm",
  components: {
    Back,
    Search,
    Close,
    DateRangePicker,
    Autocomplete,
  },
  data() {
    return {
      loading: false,
      loadingButton: false,
      loadingSupplier: false,
      loadingPenerima: false,
      po: {
        no_po: `Baru`,
        id_toko: this.$toko.id,
        id: this.$route.params.id,
        id_perusahaan: -1,
        id_penerima: -1,
      },
      detail: [
        {
          id: Date.now(),
          id_barang: -1,
          nama: "",
          satuan: "",
          harga: null,
          jumlah: null,
          total: null,
          show: true,
        },
      ],
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
      },
      hoveredBahanBaku: -1,
      dataBahanBaku: [],
      dataSupplier: [],
      dataOutlet: [],
      pembayaran: [],
      deletedItems: [],
    };
  },
  computed: {
    totalBayar() {
      let total = 0;
      this.pembayaran.forEach((item) => {
        total += parseInt(item.jumlah_bayar);
      });

      return total;
    },
    grandTotal() {
      let total = 0;
      this.detail.forEach((item) => {
        if (item.jumlah && item.harga) {
          total += parseFloat(item.jumlah) * parseFloat(item.harga);
        }
      });

      return total;
    },
  },
  methods: {
    moment,
    loadBahanbaku() {
      api.get("/v4/bahan-baku?id_toko=" + this.$toko.id).then((r) => {
        this.dataBahanBaku = r.data;
      });
    },
    loadData() {
      this.loading = true;
      api
        .get("/v4/pembelian/detail?id=" + this.po.id)
        .then((r) => {
          this.loading = false;
          this.po = r.data.pembelian;
          this.detail = r.data.pembelian_detail;
          this.pembayaran = r.data.pembelian_pembayaran;

          this.dateRange.startDate = r.data.pembelian.tanggal;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    async loadOutlet() {
      this.loadingPenerima = true;

      const outlet = await api.get("/v4/toko/outlet?id=" + this.$toko.id);

      this.loadingPenerima = false;

      const data = [this.$toko];
      data.concat(outlet.data);

      this.dataOutlet = data;

      this.po.id_penerima = data[0].id;
    },
    async loadSupplier() {
      this.loadingSupplier = true;
      const r = await api.get("/v4/supplier?id_toko=" + this.$toko.id);
      this.loadingSupplier = false;

      this.dataSupplier = r.data;
    },
    calculateTotalBayar() {
      this.pembayaran[0] = this.po.jumlah_bayar;
    },
    filterBahanBaku(nama) {
      this.dataBahanBaku = this.$store.state.bahanBaku.data.filter((item) => {
        return item.nama.toLowerCase().indexOf(nama.toLowerCase()) > -1;
      });
    },
    chooseBahanBaku(e, item) {
      this.filterBahanBaku(item.nama);

      if (item.nama && this.dataBahanBaku.length > 0) {
        item.openAutocomplete = true;
      } else {
        item.openAutocomplete = false;
      }

      if (e.keyCode == 40) {
        if (this.hoveredBahanBaku < this.dataBahanBaku.length - 1) {
          this.hoveredBahanBaku = this.hoveredBahanBaku + 1;
        }
      } else if (e.keyCode == 38) {
        if (this.hoveredBahanBaku > 0) {
          this.hoveredBahanBaku = this.hoveredBahanBaku - 1;
        }
      } else if (e.keyCode == 13) {
        e.stopPropagation();
        // I think it's reverted
        if (item.openAutocomplete) {
          this.selectBahanBaku(this.hoveredBahanBaku, item);
          item.openAutocomplete = false;
        } else {
          this.tambahBarang();
        }
      }
    },
    selectBahanBaku(index, item) {
      const bahanBaku = this.dataBahanBaku[index];

      item.nama = bahanBaku.nama;
      item.satuan = bahanBaku.satuan;
      item.harga = bahanBaku.harga;
      item.jumlah = 1;
      item.openAutocomplete = false;

      this.hoveredBahanBaku = -1;
    },
    tambahBarang() {
      this.detail.push({
        id_barang: -1,
        nama: "",
        satuan: "",
        harga: null,
        jumlah: null,
        total: null,
        show: true,
      });
    },
    remove(item, index) {
      this.deletedItems.push(item);
      this.detail.splice(index - 1, 1);
    },
    setRow(event, row) {
      row.id_barang = event.id;
      row.nama = event.nama;
      row.harga = event.harga_beli;
      row.per = event.per;
      row.satuan = event.satuan;
      row.jumlah = 1;
    },
    save() {
      // Check detail items

      let valid = true;
      this.detail.forEach((item) => {
        if (!item.jumlah || !item.harga) {
          valid = false;
        }
      });

      if (!valid) {
        this.$toast("Detail item harus dilengkapin ya");
        return;
      }

      if (this.po.id == -1) {
        delete this.po.id;
      }

      this.po.tanggal = this.dateRange.startDate;
      this.po.id_user = this.$user.id;
      this.po.detail = this.detail;
      this.po.grand_total = this.grandTotal;
      this.po.jumlah_bayar = this.po.jumlah_bayar || 0;

      // for update only
      if (this.po.id) {
        this.po.deleted_items = this.deletedItems;
      }

      console.log(this.po);
      this.loadingButton = true;
      api
        .post("/v4/pembelian/save", this.po)
        .then((r) => {
          this.loadingButton = false;
          if (r.valid) {
            this.$router.go(-1);
          } else {
            this.$toast("Ada yang bermasalah di server kami");
          }
        })
        .catch((e) => {
          this.loadingButton = false;
          this.$toast(
            "Gagal menyimpan data ke server. Silakan ulangi kembali."
          );
        });
    },
    getSupplier(id_perusahaan) {
      console.log(this.po.id_perusahaan);
      if (id_perusahaan > 0) {
        return this.dataSupplier.find((k) => k.id == id_perusahaan).nama;
      } else {
        return "Tanpa supplier";
      }
    },
    getPenerima(id_outlet) {
      if (this.dataOutlet.length > 0) {
        return this.dataOutlet.find((k) => k.id == id_outlet).nama;
      } else {
        return "-";
      }
    },
    cetak() {
      window.print();
    },
  },
  mounted() {
    // this.$store.commit("settings/setMenuActive  ", "/transaksi/purchase-order");
    this.loadBahanbaku();
    this.loadOutlet();
    this.loadSupplier();

    if (this.$route.params.id > 0) {
      this.loadData();
    }
  },
};
</script>

<style scoped lang="scss">
.page {
  > div {
    margin: 20px;
  }
  h2 {
    display: flex;
    align-items: center;
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    .ionicon {
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .btn-cetak {
    position: absolute;
    right: 35px;
    margin-top: -45px;
    width: 100px;
    padding: 10px;
  }

  .form-top {
    display: grid;
    grid-template-columns: 370px 1fr 1fr;
    grid-column-gap: 15px;
    width: 75%;
    .form-group {
      margin-bottom: 11px;
    }
  }

  p {
    color: var(--primary);
  }

  .table-wrappers {
    margin-top: 15px;
    a.btn-hapus {
      color: red;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    .btn-tambah-barang {
      display: block;
      padding: 10px 0;
      color: var(--primary);
      &:hover {
        text-decoration: underline;
      }
    }

    input:disabled {
      background: #eee;
    }
  }

  .pembayaran {
    margin-top: 20px;
    width: 400px;
    > div {
      border: 1px solid #ddd;
      border-radius: 7px;
      padding: 15px;
    }
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      margin-top: 10px;
      li {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        font-size: 14px;

        span {
          &:last-child {
            padding-left: 100px;
            display: block;
            text-align: right;
          }
        }

        input {
          border: 0;
          border-bottom: 1px solid #ddd;
          border-radius: 0;
          padding-right: 0;
          margin-right: 0;
          width: 100%;
          font-size: 14px;
          text-align: right;
          &:focus {
            background: #eef8fb;
          }
        }
      }
    }

    .btn-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 15px;
    }
  }

  .btn-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
  }

  .print {
    display: none;
  }
}
</style>
<style lang="scss">
#faktur-print {
  display: none;
  h2 {
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
    font-size: 18px;
  }

  table {
    border-collapse: collapse;
    tr {
      td {
        padding: 5px;
      }
    }

    &.table-detail {
      width: 100%;
      thead {
        tr {
          th {
            background-color: #eee;
            padding: 10px 5px;
            font-size: 14px;
            text-align: left;
          }
        }
      }
      tbody {
        tr {
          td {
            border-bottom: 1px solid #eee;
            padding: 10px 5px;
            font-size: 14px;
          }
        }
      }

      tfoot {
        tr {
          td {
            padding: 10px 5px;
            font-size: 14px;
          }
        }
      }
    }
  }
}

@media print {
  #app {
    visibility: hidden;
  }

  #faktur-print {
    display: block !important;
    visibility: visible;
    margin: 1cm;
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 2cm);
  }
}

@page {
  size: auto;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/transaksi/PembelianForm.vue